import { Button, Stack, useDisclosure } from '@chakra-ui/react'
import { faUserMinus } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import SeriesQ from '@/queries/SeriesQ'
import type { Query } from '@/client/query'

import Tippy from '@/components/UI/Tippy'

import SeriesReservationCancelModal from './SeriesReservationCancelModal'

const TOOLTIP_TEXT =
  'If you feel like you wont be able to make it, you may cancel your reservation.'

export default function SeriesReservationCancel({
  series,
  isUserSelfReserved,
}: {
  series: Query
  isUserSelfReserved: boolean
}) {
  const { onClose, isOpen, onOpen } = useDisclosure()

  const seriesId = series(SeriesQ.id) ?? 0

  return (
    <>
      <SeriesReservationCancelModal seriesId={seriesId} isOpen={isOpen} onClose={onClose} />
      {isUserSelfReserved ? (
        <Stack direction="column" spacing="12px">
          <Tippy content={TOOLTIP_TEXT}>
            <Button
              onClick={onOpen}
              variant="outline"
              color="fg.error"
              leftIcon={<FontAwesomeIcon icon={faUserMinus} />}
            >
              Cancel Reservation
            </Button>
          </Tippy>
        </Stack>
      ) : null}
    </>
  )
}
